import { render, staticRenderFns } from "./DocFaceDetails.vue?vue&type=template&id=c37ab0f0&scoped=true"
import script from "./DocFaceDetails.vue?vue&type=script&lang=js"
export * from "./DocFaceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37ab0f0",
  null
  
)

export default component.exports